<template>
  <div>
    <Loading :visible="saveLoading" :error="true">
      <div slot="infoContent">
        <v-alert color="info" v-model="saveLoading">
          <div style="text-align: center;" class="mb-3">
            <v-progress-circular class="loading-icon mr-2" indeterminate></v-progress-circular>
            <b>Uploading {{files.length}} files...</b>
          </div>
          <div>Do not close or refresh this window until all files are uploaded.</div>
        </v-alert>
      </div>
    </Loading>
    <v-card-text style="height: 532px; overflow: auto;" v-if="list_type && contents">
      <v-layout row wrap>
        <v-flex xs12 pr-1>

        </v-flex>
        <v-flex xs12 pr-1 mb-2>
          <div class="pa-2 elevation-4" style="border-radius: 2px;">
            <v-select label="File Field" :items="fileFields" item-text="title" item-value="name" v-model="fileField"></v-select>
            <v-select label="Name field" :items="nameFields" item-text="title" item-value="name" v-model="nameField" clearable></v-select>
            <div style="display: flex;">
              <v-spacer></v-spacer>
              <v-btn

                @click.stop="onPickFiles"
              >
                Select files...
              </v-btn>
            </div>
            <input type="file" ref="fileInput" style="display: none" multiple accept="*/*" @change="onFilesPicked"/>
            <v-divider class="mt-1 mb-1" />
            <v-layout row wrap style="max-height: 160px; overflow-y: auto;">
              <v-flex xl4 lg6 md6 sm12 xs12 v-for="file in files">
                <v-chip small close @input="removeFile(file)"><span class="text-truncate">{{file.name}}</span></v-chip>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs4 pr-1 mb-2>
          <v-btn @click.stop="create_data()">Convert</v-btn>
        </v-flex>
        <v-flex xs12 pr-1>
          <table>
            <tbody>
              <tr v-for="line in converted">
                <td v-for="row in line">
                  {{row}}
                </td>
              </tr>
            </tbody>
          </table>

        </v-flex>

      </v-layout>

      <template v-for="editor in editors">
        <div class="elevation-4">
        <editor :data="id" ref="editors" :initial="editor" :noheight="true" :hideactions="true"></editor>
      </div>
      </template>


    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="save(true)" :disabled="saveLoading" :loading="saveLoading">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import * as FormItems from '@/components/form_items'
import ContentModel from '@/models/content.js'
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue'
import Papa from 'papaparse';
import Editor from './Editor';
import Loading from "@/components/Loading"

export default {
  props: ['id', 'data_id'],

  data () {
    return {
      channel: undefined,
      list_data: {},
      is_headers: false,
      row_delimiter: "\t",
      data: [],
      converted: [],
      editors: [],
      files: [],
      fileField: "",
      nameField: "",
      saveLoading: false
    }
  },
  components: {
    Editor,
    Loading
  },
  computed: {
    headers () {
      var ret = [{ text: 'Id', value: 'id', align: 'left' }];
      _.each(this.fields, (field) => {
        ret.push({ text: field.title, value: 'data.' + field.name, align: 'left', sortable: true});
      });
      ret.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false});
      return ret;
    },
    contents () {
      return Object.values(this.list_data);
    },

    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.id;
      });
    },
    fields () {
      var lt = this.list_type;
      return lt.fields["fields"]
    },
    nameFields() {
      return _.filter(this.fields, (field) => {
        return field.type == "text"
      });
    },
    fileFields() {
      return _.filter(this.fields, (field) => {
        return field.type == "file" || field.type == "s3file"
      });
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
  
  },
  mounted() {
    this.connect_ws();
  },
  beforeDestroy: function() {
    this.channel.leave();
  },
  methods: {
    create_data () {
      if(_.isEmpty(this.fileField)) return;
      this.editors = _.map(this.files, (file) => {
        var retdata = {};

        retdata[this.fileField] = file;
        if(!_.isEmpty(this.nameField)) {
          retdata[this.nameField] = file.name.split('.').slice(0, -1).join('.');
        }

        return retdata;
      });

    },
    onPickFiles() {
      this.$refs.fileInput.click();
    },
    onFilesPicked(event) {
      const files = event.target.files
      this.files = files
    },
    removeFile(file) {
      this.files = _.filter(this.files, (f) => { return f.name != file.name });
    },

    reset() {

    },
    save (close) {
      this.saveLoading = true;
      var promises = _.map(this.$refs.editors, (editor) => {
        return new Promise((resolve, reject) => { editor.save(false, true, resolve, reject) });
      });
      Promise.allSettled(promises).then((results) => {
        if(_.countBy(results, (r) => { return r.status })["fulfilled"] == promises.length) {
          this.$message.success("Files uploaded!");
          this.saveLoading = false;
          if (close) {
            this.$root.close_bottom_sheet();
          }

        } else {
          this.saveLoading = false;
          this.$message.success("Unable to upload files!");
        }
      });

    },
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$socket.channel("cms:list_datas:"+this.id);
      this.channel.on("init", function(msg) {
        msg.list_data.forEach(function(d) {
          Vue.set(self.list_data, d.id, d);
        });
      });
      this.channel.on("update", function(msg) {
        Vue.set(self.list_data, msg.list_data.id, msg.list_data);
      });
      this.channel.on("delete", function(msg) {
        Vue.delete(self.list_data, msg.list_data.id);
      });
      this.channel.join();
    }
  }
}
</script>
